import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function calculateSolar(payload) {
  const { data } = await api.post("/calculator", payload);
  return data;
}

export async function listLeads() {
  const { data } = await api.get("/leads");
  return data;
}

export async function leadStats() {
  const { data } = await api.get("/leads/stats");
  return data;
}
